<tui-drawer *tuiPopup="open()" style="inline-size:40.25rem;">
  <div class="tui-scrollbar">
    <header tuiHeader>
      <h6 tuiTitle [style.font]="'var(--tui-font-heading-6)'">Where you're logged in
        <span tuiSubtitle>
          You're signed in on these devices or have been in the last 28 days.
          There might be multiple activity sessions from the same device.
          <button tuiLink type="button" [style.text-decoration-line]="'underline'"
            [textContent]="'How locations and times are determined?'"></button>
        </span>
      </h6>
      <button tuiIconButton tuiButtonClose type="button" (click)="closeDrawer()">
        Close
      </button>
    </header>
    <!-- login info -->
    <div tuiAppearance="flat" [style.borderRadius.rem]="0.75" [style.padding-right]="'0'" [style.padding-left]="'0'"
      [style.padding-top]="'1.5rem'" *ngIf="activeSessions().length > 0 && !loading()">
      <div class="info-table login-info-table">
        <tui-loader [overlay]="true" [showLoader]="loading()">
          <table tuiTable class="table" [columns]="deviceColumns" size="s" [style.width]="'100%'">
            <thead>
              <tr tuiThGroup>
                <th tuiTh [resizable]="true">
                  DEVICE
                </th>
                <th tuiTh>LOCATION</th>
                <!-- <th tuiTh>FIRST SIGN-IN</th> -->
                <th tuiTh>LAST ACTIVITY</th>
                <th tuiTh [style.text-align]="'right'"></th>
              </tr>
            </thead>
            <tbody tuiTbody [data]="activeSessions()">
              <tr *ngFor="let item of activeSessions()" tuiTr>
                <td *tuiCell="'device'" tuiTd>
                  <div tuiCell="m">
                    <tui-avatar size="s" appearance="secondary" [src]="item.device.icon"
                      [style.color]="'var(--tui-text-secondary)'" [style.border-radius.rem]="0.725" />
                    <div tuiTitle>
                      <div class="device-name-row">
                        <span class="ttui-text_body-m-2 bold" [style.text-transform]="'capitalize'">{{ item.device.name }}</span>
                        <tui-badge *ngIf="item.isCurrent" appearance="positive" tuiStatus size="s">
                          Current
                        </tui-badge>
                      </div>
                      <div tuiSubtitle>
                        {{ item.device.browser }} • {{ item.device.ip }}
                      </div>
                    </div>
                  </div>
                </td>
                <td *tuiCell="'location'" tuiTd>
                  <tui-icon icon="@tui.map-pin" [style.color]="'var(--tui-text-secondary)'" size="s"
                    [style.width.px]="16" /> {{ item.location }}
                </td>
                <td *tuiCell="'last-activity'" tuiTd>{{ item.lastActivity ? (item.lastActivity | date:'d MMM, h:mm a') :
                  'Just now' }}</td>
                <td *tuiCell="'action'" tuiTd [style.text-align]="'right'">
                  <button appearance="flat" size="s" tuiIconButton type="button"
                    [style.color]="item.isCurrent ? 'var(--tui-status-negative)' : 'var(--tui-text-secondary)'"
                    (click)="logoutDevice(item)">
                    <tui-icon class="hover-logout" appearance="flat"
                      [tuiTooltip]="item.isCurrent ? 'Log out from this account' : 'Logout this device'"
                      tuiHintDirection="left" [style.color]="'var(--tui-status-negative)'" icon="@tui.log-out" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </tui-loader>
      </div>
    </div>
    <footer class="footer-button" *ngIf="activeSessions().length > 0 && !loading()">
      <button tuiButton type="button" [style.color]="'#DD4C1E'" appearance="flat" size="m"
        (click)="logoutAllSessions()">
        Log out of all sessions
      </button>
    </footer>
  </div>
  <app-empty-state *ngIf="activeSessions().length === 0 && !loading()" title="No active sessions found"
    message="You're all set! There are no active sessions on this account." imageSrc="/assets/images/icons/camping.svg"
    imageAlt="No active sessions found" />
</tui-drawer>